import { useRouter } from 'vue-router';
import { useMatrixPageOrigin } from './useMatrixPageOrigin';

export function useOpenFillLogs() {
  const router = useRouter();
  const { prefix, returnQuery } = useMatrixPageOrigin();

  async function openFillLogs(recordId: number): Promise<void> {
    await router.push({
      name: 'LogsDePreenchimento',
      params: { prefix: prefix(), recordId: String(recordId) },
      ...returnQuery(),
    });
  }

  return { openFillLogs };
}
